
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 11.117c-1.365-.026-2.406-.36-3.125-1-.714-.646-1.07-1.55-1.07-2.71 0-1.157.36-2.087 1.078-2.79C2.602 3.914 3.64 3.51 5 3.407V.054h1.313v3.351c1.375.042 2.416.383 3.125 1.024.713.64 1.07 1.55 1.07 2.726 0 .771-.164 1.448-.492 2.032-.329.578-.81 1.036-1.446 1.374-.635.334-1.388.519-2.258.555v3.242H5v-3.242zm0-.617V4.023c-.88.1-1.55.43-2.008.993-.453.562-.68 1.338-.68 2.328 0 .911.232 1.646.696 2.203.463.552 1.127.87 1.992.953zm1.313 0c.859-.099 1.52-.427 1.984-.984.469-.558.703-1.297.703-2.22 0-.989-.227-1.757-.68-2.304-.453-.547-1.122-.87-2.008-.969V10.5z","fill":"currentColor"}})])
          )
        }
      }
    